// vim: ft=javascriptreact
import { useState } from 'react'
import { ImperialBookingContext } from './ImperialBookingContext'
import { Auth } from 'aws-amplify'

const ImperialBookingProvider = ({ children }) => {
  const [authCheckComplete, setAuthCheckComplete] = useState(false)
  const [authError, setAuthError] = useState('')
  const [authNewPassword, setAuthNewPassword] = useState(false)
  const [authResetPassword, setAuthResetPassword] = useState(false)

  let defaultEmail
  try {
    defaultEmail = window.localStorage.getItem('email') || ''
  } catch (e) { defaultEmail = '' }

  const [email, setEmail] = useState(defaultEmail)
  const [password, setPassword] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [phone, setPhone] = useState('')
  const [isPhoneVerified, setIsPhoneVerified] = useState(false)
  const [unit, setUnitNumber] = useState("")
  const [hasPadSetUp, setHasPadSetUp] = useState(false)
  const [hasActivePhoneVerification, setHasActivePhoneVerification] = useState(false)
  const [hasExpiredPhoneVerification, setHasExpiredPhoneVerification] = useState(false)
  const [hasYetToConfirmEmail, setHasYetToConfirmEmail] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)

  const [userId, setUserId] = useState(undefined)
  const [resident, setResident] = useState(undefined)
  const [residentLoaded, setResidentLoaded] = useState(false)
  const [user, setUser] = useState(undefined)
  const [accessToken, setAccessToken] = useState(undefined)
  const [admin, setAdmin] = useState(false)
  const [nonResident, setNonResident] = useState(false)
  const [bookings, setBookings] = useState(undefined)
  const [bookingsLoaded, setBookingsLoaded] = useState(false)

  const [residents, setResidents] = useState(undefined)
  const [residentsLoaded, setResidentsLoaded] = useState(false)

  const [originalPathname, setOriginalPathname] = useState(undefined)

  const [showFacebook, setShowFacebook] = useState(!!process.env.REACT_APP_FACEBOOK_ENABLED)

  const setCognitoUser = (cognitoUser) => {
    //console.log('received cognitoUser', cognitoUser.getUsername())
    setUserId(cognitoUser.getUsername())
    setUser(cognitoUser)
    setAccessToken(cognitoUser.getSignInUserSession().getIdToken().getJwtToken())
  }

  const getCredentials = async () => {
    const user = await Auth.currentAuthenticatedUser()
    return {
      userId: user.getUsername(),
      accessToken: user.getSignInUserSession().getIdToken().getJwtToken(),
    }
  }

  const resetContext = () => {
    setUserId(undefined)
    setResident(undefined)
    setResidentLoaded(false)
    setUser(undefined)
    setAccessToken(undefined)
    setAdmin(undefined)
    setBookings(undefined)
    setBookingsLoaded(false)
    setResidents(undefined)
    setResidentsLoaded(false)
    setHasYetToConfirmEmail(false)
  }

  return (
    <ImperialBookingContext.Provider value={{
      authCheckComplete,
      setAuthCheckComplete,
      authError,
      authNewPassword,
      setAuthNewPassword,
      authResetPassword,
      setAuthResetPassword,
      setAuthError,
      getCredentials,
      hasYetToConfirmEmail,
      setHasYetToConfirmEmail,

      email,
      setEmail,
      password,
      setPassword,
      isDisabled,
      setIsDisabled,

      firstName,
      setFirstName,
      lastName,
      setLastName,
      phone,
      setPhone,
      unit,
      setUnitNumber,
      hasPadSetUp,
      setHasPadSetUp,
      isPhoneVerified,
      setIsPhoneVerified,
      hasActivePhoneVerification,
      setHasActivePhoneVerification,
      hasExpiredPhoneVerification,
      setHasExpiredPhoneVerification,

      userId,
      resident,
      residentLoaded,
      setResidentLoaded,
      user,
      accessToken,
      setResident,
      setCognitoUser,
      setAccessToken,

      admin,
      setAdmin,
      nonResident,
      setNonResident,

      bookings,
      setBookings,
      bookingsLoaded,
      setBookingsLoaded,

      residents,
      setResidents,
      residentsLoaded,
      setResidentsLoaded,

      originalPathname,
      setOriginalPathname,
      resetContext,

      showFacebook,
      setShowFacebook,
     }}>
      { children }
    </ImperialBookingContext.Provider>
  )
}

export default ImperialBookingProvider
